<script>
  export let options = [];
  export let legend = "";
  export let legendPosition = "top";
  export let labelClass = "";
  export let disabled = false;
  export let value = options.length ? options[0].value : "";

  const id = `legend-${Math.floor(Math.random() * 1000000)}`;
  const makeSlug = (str = "") => `${str}`.toLowerCase().replace(/\W/g, "");

  $: optionsWithSlug = options.map((d) => ({
    ...d,
    val: d.value,
    slug: makeSlug(d.value),
  }));
  $: isTop = legendPosition === "top";
</script>

<div class="button-set">
  <div
    id="{`group-${id}`}"
    class="group"
    class:is-top="{isTop}"
    role="radiogroup"
    aria-labelledby="{`label-${id}`}"
  >
    {#if legend}<div class="legend" id="group-{id}">{legend}</div>{/if}
    <div class="options">
      {#each optionsWithSlug as option}
        <div class="option">
          <input
            type="radio"
            id="{`${id}-${option.slug}`}"
            name="name-{id}"
            class="sr-only"
            value="{option.value}"
            disabled="{disabled}"
            bind:group="{value}"
          />
          <label class="option {labelClass}" for="{`${id}-${option.slug}`}">
            {option.label || option.value}
          </label>
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  .button-set {
    display: block;
    margin: 1em auto;
    margin-bottom: 2em;
  }

  .group {
    display: flex;
    align-items: center;
  }

  .group.is-top {
    flex-direction: column;
  }

  .is-top .legend {
    padding-bottom: 0.5em;
    padding-right: 0;
  }

  .legend {
    padding-right: 0.5em;
    font-size: 1em;
  }

  .options {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .option {
    /* width: 8em; */
    text-align: center;
  }

  label {
    appearance: none;
    user-select: none;
    line-height: 1;
    margin: 0;
    padding: 0.5em;
    border-radius: 0;
    outline: none;
    cursor: pointer;
    font-family: inherit;
    font-size: 1em;
    display: inline-block;
    border: 1px solid var(--fg);
    margin: 2px;
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"] + label {
    background-color: var(--bg);
    color: var(--fg);
    transition: all 100ms;
  }

  input[type="radio"]:checked + label,
  input[type="radio"]:checked:hover + label {
    background: var(--fg);
    color: var(--bg);
  }

  input[type="radio"]:hover + label {
    background: var(--fg);
    color: var(--bg);
  }

  input[type="radio"]:focus + label {
    box-shadow: 0 0 4px 0 var(--color-focus);
  }

  input[type="radio"]:disabled + label {
    color: var(--gray-dark);
    background: var(--gray-medium);
    cursor: not-allowed;
  }

  @media only screen and (min-width: 720px) {
    .options {
      flex-wrap: nowrap;
    }

    label {
      font-size: 1.25em;
      border: 1px solid var(--fg);
      margin: 0;
    }

    .option + .option label {
      border-left-width: 0;
    }

    .option + .option > label {
      border-left-width: 0;
    }
  }
</style>
